module.exports = __webpack_public_path__ + "static/img/algae.4f0aed7e.png";